export default __webpack_public_path__ + "static/media/dropdown_arrow.685828e3.svg";